import { BASE_URL, CITIES, COUNTRIES, PUBLIC, STATES } from "../../common/URLs";

export const fetchCountry = async () => {
  try {
    const response = await fetch(
      `${BASE_URL}/${PUBLIC}/${COUNTRIES}`,
      {
        method: "GET",
        headers: { Accept: "application/json" },
      }
    );

    const data = await response.json()
    // console.log("list of countries", data);
    return data;
  } catch (error) {
    return error
  }
};
export const fetchState = async (uuid) => {
  try {
    const response = await fetch(
      `${BASE_URL}/${PUBLIC}/${STATES}/${uuid}`,
      {
        method: "GET",
        headers: { Accept: "application/json" },
      }
    );

    const data = await response.json();
    return data;
  } catch (error) {
    return error
  }
};
export const fetchCities = async (uuid) => {
  try {
    const response = await fetch(
      `${BASE_URL}/${PUBLIC}/${CITIES}/${uuid}`,
      {
        method: "GET",
        headers: { Accept: "application/json" },
      }
    );

    const data = await response.json();
    // console.log("list of states", data);
    return data;
  } catch (error) {
    return error
  }
};